import { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';

import useNoundlesTheory from './useNoundlesTheory';

const useCompanionBalance = () => {
  const { account } = useWeb3React();
  const noundlesTheory = useNoundlesTheory();

  const [companionBalance, setCompanionBalance] = useState(0);

  useEffect(() => {
    let ignore = false;
    setCompanionBalance(0);
    if (noundlesTheory) {
      const fetchNoundles = () => {
        noundlesTheory.companionBalance(account).then((companionBalance) => {
          if (!ignore) setCompanionBalance(companionBalance.toNumber());
        });
      };
      fetchNoundles();
      const transferFrom = noundlesTheory.filters.Transfer(account);
      const transferTo = noundlesTheory.filters.Transfer(null, account);
      noundlesTheory.on(transferFrom, fetchNoundles);
      noundlesTheory.on(transferTo, fetchNoundles);
      return () => {
        noundlesTheory.off(transferFrom, fetchNoundles);
        noundlesTheory.off(transferTo, fetchNoundles);
        ignore = true;
      };
    }
  }, [noundlesTheory, account]);

  return companionBalance;
};

export default useCompanionBalance;
